import { render } from "./PromptCardInput.vue?vue&type=template&id=2bf115a8&scoped=true"
import script from "./PromptCardInput.vue?vue&type=script&lang=js"
export * from "./PromptCardInput.vue?vue&type=script&lang=js"

import "./PromptCardInput.vue?vue&type=style&index=0&id=2bf115a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf115a8"]])

export default __exports__